import type { BlockExport } from "@circle-react-shared/BuilderUI/BuilderUI.types";
import { ContactItem as Block } from "./ContactItemBlock";
import { defaultData } from "./ContactItemBlockDefaultData";
import imagePreview from "./contact_item_block.png";

export const ContactItemBlock: BlockExport = {
  type: "component",
  Block,
  imagePreview: {
    type: "image-url",
    lg: imagePreview,
  },
  defaultData,
  meta: {
    name: "Contact Item",
    version: 1,
    nameI18n: "builder_ui.block_type.contact_item",
    isHidden: true,
    props: {
      content: {
        name: "Content",
        nameI18n: "builder_ui.prop_type.content",
        prop: "children",
        accepts: ["Basic", "Media", "Text", "Actions", "Layout"],
        type: "children",
      },
    },
  },
};
